// extracted by mini-css-extract-plugin
var _1 = "styles-module__card___LMkNa";
var _2 = "styles-module__container___DEMCD";
var _3 = "styles-module__innerContainer___lTeqm";
var _4 = "styles-module__river___au3lY";
var _5 = "styles-module__shimmer___HUqfS";
var _6 = "styles-module__title___ma6kr";
export { _1 as "card", _2 as "container", _3 as "innerContainer", _4 as "river", _5 as "shimmer", _6 as "title" }
